import { ICommand } from "Application";
import { Box, Button, Label } from "Components";
import { CloseIcon } from "Styles/ThemedPrimitives/Style1/CloseIcon";
import React from "react";
import { WeeklyRotaDetailsViewModel } from "../WeeklyRotaDetail/WeeklyRotaDetailViewModel";
import { Container, DataScroll, DayHeaderCell, Footer, ButtonGroup, SlotHeaderCell, StyledDialog, Header, StudentNameCell, TableInnerData } from "./SessionLeftModal.styles";

export interface IProps {
    closeCommand: ICommand;
    viewModel: WeeklyRotaDetailsViewModel;
}

const SessionLeftModal: React.FC<IProps> = ({ closeCommand, viewModel }) => (
    <>
        <StyledDialog open={true} style={{ zIndex: 1 }}>
            <Header>
                Sessions left to assign <CloseIcon onClick={closeCommand.execute} />
            </Header>
            <Container>
                <SessionLeftContent viewModel={viewModel} />
                <SessionLeftFooter closeCommand={closeCommand} />
            </Container>
        </StyledDialog>
    </>
);

const SessionLeftContent: React.FC<{ viewModel: WeeklyRotaDetailsViewModel }> = ({ viewModel }) => (
    <DataScroll maxHeight="44vh" overflowY="auto">
        {viewModel.sessionLeftByDay.map(({ day, am, pm }) => (
            <Box flex={"1 0 0"} key={day}>
                <DayHeaderCell>
                    <Label fontStyle="h4">{day}</Label>
                </DayHeaderCell>
                <Box display={"grid"} gridTemplateColumns={"1fr 1fr"} alignItems={"flex-start"} style={{ gap: "2px" }}>
                    {[
                        { name: "am", students: am },
                        { name: "pm", students: pm },
                    ].map(({ name, students }) => (
                        <Box display={"grid"} style={{ gap: "2px" }} key={name}>
                            <SlotHeaderCell>
                                <Label fontStyle="h4">{name}</Label>
                            </SlotHeaderCell>
                            <TableInnerData>
                                {students.map((studentName) => (
                                    <StudentNameCell key={studentName}>{studentName}</StudentNameCell>
                                ))}
                            </TableInnerData>
                        </Box>
                    ))}
                </Box>
            </Box>
        ))}
    </DataScroll>
);

const SessionLeftFooter: React.FC<{ closeCommand: ICommand }> = ({ closeCommand }) => (
    <Footer>
        <ButtonGroup>
            <Button command={closeCommand} displayName={"CANCEL"} paletteColor="secondary" />
        </ButtonGroup>
    </Footer>
);

export default SessionLeftModal;
